var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.388,
    height: 23.065,
    viewBox: "0 0 27.388 23.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480",
    transform: "translate(-10467.441 -9777.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(10467.941 9778.209)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 7.655,
    cy: 7.655,
    r: 7.655,
    transform: "translate(2.372 10.826) rotate(-45)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5079",
    "data-name": "Path 5079",
    d: "M1139.605,993.15a4.709,4.709,0,0,0-7.905,3.462,4.682,4.682,0,0,0,.442,2",
    transform: "translate(-1123.218 -985.805)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5080",
    "data-name": "Path 5080",
    d: "M1140,1013.578a4.715,4.715,0,0,0,7.828-3.539,5.054,5.054,0,0,0-.25-1.539",
    transform: "translate(-1129.922 -999.212)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5084",
    "data-name": "Path 5084",
    d: "M1100.794,992s-7.27.346-13.194-7.655c5.924-8.02,13.194-7.655,13.194-7.655",
    transform: "translate(-1087.6 -973.517)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5085",
    "data-name": "Path 5085",
    d: "M1156.2,992s7.27.346,13.194-7.655c-5.924-8.02-13.194-7.655-13.194-7.655",
    transform: "translate(-1143.006 -973.517)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 3,
    cy: 2.5,
    rx: 3,
    ry: 2.5,
    transform: "translate(10477.831 9786.86)",
    fill: "#ffc524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.815a0baf2b428a66299d4091bc5fb8f5.svg";
export { ForwardRef as ReactComponent };